import React, { useState, useMemo, useCallback } from "react";

import ProcessedReservation from "./ProcessedReservation/ProcessedReservation";
import ReservationPayment from "./ReservationPayment/ReservationPayment";
import DepositHistory from "./DepositHistory/DepositHistory";
import CustomerServiceList from "./CustomerList/CustomerServiceList";
import RequestPayment from "./RequestPayment/RequestPayment";

import card1 from "../../assets/cards/card1.svg";
import card2 from "../../assets/cards/card2.svg";
import card3 from "../../assets/cards/card3.svg";
import card5 from "../../assets/cards/card5.svg";

import { UsergroupAddOutlined } from "@ant-design/icons";
import { useQuery } from "@tanstack/react-query";
import { fetchDashboardStats } from "../../utils/CustomerService/api";

const tabs = [
  { label: "Processed Reservation", component: <ProcessedReservation /> },
  { label: "Reservation Payment", component: <ReservationPayment /> },
  { label: "Deposit History", component: <DepositHistory /> },
  { label: "Customer List", component: <CustomerServiceList /> },
  { label: "Request Payment", component: <RequestPayment /> },
];

function CustomerService() {
  const [activeTab, setActiveTab] = useState(tabs[0].label);

  const handleTabClick = useCallback((tab) => setActiveTab(tab), []);

  const {
    data: stat,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ["stats"],
    queryFn: () => fetchDashboardStats(),
  });

  const activeComponent = useMemo(
    () => tabs.find((tab) => tab.label === activeTab)?.component,
    [activeTab]
  );

// eslint-disable-next-line react-hooks/exhaustive-deps
  const reportData = React.useMemo(() => {
    if (isLoading) {
      return Array(4).fill({ label: "Loading...", value: "Loading..." });
    }

    if (isError) {
      return [
        {
          label: "Error",
          value: error.message || "Failed",
        },
      ];
    }

    return [
      {
        label: "Available Rooms",
        value: stat.available_rooms || "0",
        icon: (
          <i
            class="fa-solid fa-door-closed text-blue-500"
            className="text-3xl text-blue-500"
            style={{ fontSize: "20px" }}
          ></i>
        ),
        textColor: "text-blue-600",
        bgImage: card1,
      },
      {
        label: "Reserved Rooms",
        value: stat?.reserved_rooms || "0",
        icon: (
          <i
            class="fa-solid fa-bed"
            className="fa-solid fa-bed text-3xl text-yellow-500"
            style={{ fontSize: "20px" }}
          ></i>
        ),
        // icon: <BookOutlined className="text-3xl text-yellow-500" />,
        textColor: "text-yellow-600",
        bgImage: card2,
      },
      {
        label: "Total users",
        value: stat?.total_customer || "0",
        icon: <UsergroupAddOutlined className="text-3xl text-green-500" />,
        textColor: "text-green-600",
        bgImage: card3,
      },
      {
        label: "With Telegram Account",
        value: stat?.with_telegram_account || "0",
        icon: <i class="fa-brands fa-telegram text-2xl text-[#9333EA]"></i>,
        textColor: "text-purple-600",
        bgImage: card5,
      },
    ];
  });

  return (
    <div className="p-2 sm:p-4 min-h-screen text-gray-900 dark:text-white dark:bg-gray-800 rounded-md">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 max-w-7xl w-full">
        {reportData.map((item, index) => (
          <div
            key={index}
            className="bg-white p-6 rounded-xl shadow-lg flex flex-col  dark:text-white dark:bg-gray-900"
            style={{
              backgroundImage: `url(${item.bgImage})`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "bottom",
            }}
          >
            <div className="flex items-center gap-2 mb-4">
              {item.icon}
              <h2 className={`text-sm font-semibold ${item.textColor}`}>
                {item.label}
              </h2>
            </div>
            <p className="text-2xl font-bold mb-4">{item.value}</p>
          </div>
        ))}
      </div>

      <br />
      <br />

      <div className="flex flex-col md:flex-row overflow-x-auto whitespace-nowrap gap-2 sm:gap-4 p-2 rounded-lg bg-[#55497C] dark:bg-[#55497C]">
        {tabs.map(({ label }) => (
          <button
            key={label}
            onClick={() => handleTabClick(label)}
            className={`bg-transparent px-4 py-2 rounded-lg font-medium transition-all hover:bg-[#6c5d9c] flex-shrink-0 ${
              activeTab === label
                ? "bg-[#6c5d9c] text-white"
                : "bg-gray-300 text-white dark:bg-gray-700 dark:text-white"
            }`}
          >
            {label}
          </button>
        ))}
      </div>
      <div className="mt-4">{activeComponent}</div>
    </div>
  );
}

export default CustomerService;
